import React from "react";
import { Button } from "./Button";
import { Link } from 'react-router-dom';
import './VideoSection.css';

function VideoSection2() {
  return (
    <div className="video-container2"> 
      <video src="/videos/vid2.mp4" className="video2" autoPlay loop muted/>
      <div className="vid2-content">
        <h1>Be a hero <i>and</i> make a friend for life?</h1>
        <p>Sounds like a good deal if you ask us.</p>
        <Link to='/signup' className='btn-link'>
          <Button
            className='video-btns'
            buttonSize='btn--large'
            buttonStyle='btn--other'>
            SIGN UP TODAY
          </Button>
        </Link>
      </div>
    </div>
  )
}

export default VideoSection2